/**
 * Created by hp on 2017/6/6.
 */
import React, { Component } from 'react';
import {connect} from 'react-redux';


class ClassroomNoSleepVideo extends Component{
    state = {
        paused: true
    }

    isAndroid(){
        return navigator.userAgent.toLowerCase().indexOf('android') > -1;
    }

    isIOS(){
        return !this.isAndroid() && navigator.userAgent.indexOf('iP') > -1;
    }

    isWechat(){
        return (/MicroMessenger/.test(navigator.userAgent) && !/WindowsWechat/.test(navigator.userAgent));
    }

    isRecording(){
        return (this.props.recorderState === 'start' ||
        this.props.recorderState === 'check' ||
        this.props.recorderState === 'stop' ||
        this.props.recorderState === 'force_stop' ||
        this.props.recorderState === 'recording');
    }

    lastPlayingTime = null
    isPlayingAudio(){
        // 判断是否正在播放，判断准则为，audioState为playing，或者离上次播放状态5分钟内
        if(this.props.audioState === 'playing'){
            this.lastPlayingTime = Date.now()
            return true
        }
        if(this.lastPlayingTime && (Date.now() - this.lastPlayingTime) < 5*60*1000){
            return true
        }
        return false
    }

    componentDidMount(){
        this.ticks = setInterval(()=>{
            if(this.refs.video){
                if(this.shouldPlay() && this.isPlayingAudio()){
                    this.refs.video.play();
                }
                if(this.state.paused !== this.refs.video.paused){
                    this.setState({paused: this.refs.video.paused});
                }
                this.forceUpdate()
            }
        }, 5000);

        this.enableNoSleepHandler = this.enableNoSleep.bind(this);
        document.addEventListener('touchstart', this.enableNoSleepHandler, false);
    }

    enableNoSleep(){
        document.removeEventListener('touchstart', this.enableNoSleepHandler, false);
        if(this.refs.video && !this.isRecording()){
            this.refs.video.play();
        }
    }

    shouldPlay(){
        if(!this.refs.video)
            return false;
        if(!this.refs.video.paused)
            return false;
        if(this.props.showMaterialPanel)
            return false;
        if(this.props.showVideoPlayer)
            return false;
        if(this.isRecording())
            return false;

        const topVideo = document.getElementById('top_video');
        if(topVideo && !topVideo.paused)
            return false;
        return true;
    }

    componentWillUnmount(){
        clearInterval(this.ticks);
    }

    componentDidUpdate(){
        if(this.props.wechat && this.props.wechat.ready){
            if(this.shouldPlay()){
                this.refs.video.play();
            }
        }
    }

    render(){
        const debug = false;
        // const shouldChangeBase64 = !(/MQQBrowser/.test(navigator.userAgent)) && /Safari/.test(navigator.userAgent)
        const shouldChangeBase64 = (+this.props.account.id === 51692197) || (+this.props.account.id === 45286782)
        return (<div>
            <p style={{position: 'fixed', zIndex: 100, color: 'red', display: debug?'':'none'}}>
                nsv paused: {this.state.paused.toString()} <br />
                wkwebview: {(window.__wxjs_is_wkwebview || false).toString()} <br />
                audioState: {this.props.audioState} <br />
                recorderState: {this.props.recorderState}
            </p>
            {this.isWechat() && this.isAndroid() && !shouldChangeBase64 &&
            <video is id="no-sleep-video"
                   width="10" height="10"
                   loop="loop"
                   playsinline="true"
                   webkit-playsinline="true"
                   x-webkit-airplay="true"
                   style={{position: 'absolute', left: '-1000px', top: '-1000px'}}
                   preload="none" ref="video">
                 <source src="data:video/mp4;base64,AAAAHGZ0eXBpc29tAAACAGlzb21pc28ybXA0MQAAAAhmcmVlAAAAG21kYXQAAAGzABAHAAABthADAowdbb9/AAAC6W1vb3YAAABsbXZoZAAAAAB8JbCAfCWwgAAAA+gAAAAAAAEAAAEAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAAAIVdHJhawAAAFx0a2hkAAAAD3wlsIB8JbCAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAQAAAAAAIAAAACAAAAAABsW1kaWEAAAAgbWRoZAAAAAB8JbCAfCWwgAAAA+gAAAAAVcQAAAAAAC1oZGxyAAAAAAAAAAB2aWRlAAAAAAAAAAAAAAAAVmlkZW9IYW5kbGVyAAAAAVxtaW5mAAAAFHZtaGQAAAABAAAAAAAAAAAAAAAkZGluZgAAABxkcmVmAAAAAAAAAAEAAAAMdXJsIAAAAAEAAAEcc3RibAAAALhzdHNkAAAAAAAAAAEAAACobXA0dgAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAIAAgASAAAAEgAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABj//wAAAFJlc2RzAAAAAANEAAEABDwgEQAAAAADDUAAAAAABS0AAAGwAQAAAbWJEwAAAQAAAAEgAMSNiB9FAEQBFGMAAAGyTGF2YzUyLjg3LjQGAQIAAAAYc3R0cwAAAAAAAAABAAAAAQAAAAAAAAAcc3RzYwAAAAAAAAABAAAAAQAAAAEAAAABAAAAFHN0c3oAAAAAAAAAEwAAAAEAAAAUc3RjbwAAAAAAAAABAAAALAAAAGB1ZHRhAAAAWG1ldGEAAAAAAAAAIWhkbHIAAAAAAAAAAG1kaXJhcHBsAAAAAAAAAAAAAAAAK2lsc3QAAAAjqXRvbwAAABtkYXRhAAAAAQAAAABMYXZmNTIuNzguMw==" type="video/mp4" />
            </video>
            }
            {this.isWechat() && this.isAndroid() && shouldChangeBase64 &&
            <video is id="no-sleep-video"
                   width="10" height="10"
                   loop="loop"
                   playsinline="true"
                   webkit-playsinline="true"
                   x-webkit-airplay="true"
                   style={{position: 'absolute', left: '-1000px', top: '-1000px'}}
                   preload="none" ref="video"
                   src="https://audio-1253442168.file.myqcloud.com/test/WeChatSight15.mp4">
            </video>
            }
            {this.isWechat() && this.isIOS() &&
            <video is id="no-sleep-video"
                   width="100%" height="100%"
                   playsinline="true"
                   webkit-playsinline=""
                   tvp_loadingad_ended="1" data-playing-loadingad="0"
                   x-webkit-airplay="true"
                   style={{position: 'absolute', left: '-1000px', top: '-1000px'}}
                   preload="none" ref="video"
                   src="https://audio-1253442168.file.myqcloud.com/test/WeChatSight15.mp4">
            </video>
            }

        </div>);
    }
}


export default connect((state) => ({
    account: state.account,
    wechat: state.wechat,
    audioState: state.audioPlayer.audioState,
    recorderState: state.audioRecorder.recorderState,
    showMaterialPanel: state.classroom.showMaterialPanel,
    showVideoPlayer: state.videoPlayer.showVideoPlayer
}))(ClassroomNoSleepVideo);




// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomNoSleepVideo.js